import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';
import { LoganLanguage } from 'src/app/core/models/commons.model';
import { User } from 'src/app/core/models/persons.model';

import { AuthService } from 'src/app/core/services/auth.service';
import { LoganTranslateService } from 'src/app/core/services/translate.service';
import { InfosComponent } from 'src/app/pages/infos/infos.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
  providers: [InfosComponent],
})

/**
 * Topbar Component
 */
export class TopbarComponent implements OnInit {
  mode: string | undefined;
  element: any;
  flagvalue: any;
  currentLang: any;
  countryName: any;
  languages: Array<LoganLanguage>;
  user: User;
  timeToExpired = 0;
  tokenExpired = false;
  showInfo = false;
  isUserAdmin = false;
  isUserAll = false;
  isLocalhost = window.location.hostname.startsWith('localhost');
  isProd = environment.production;

  @Output() mobileMenuButtonClicked = new EventEmitter();

  constructor(
    private router: Router,
    public languageService: LoganTranslateService,
    public translate: TranslateService,
    private authService: AuthService,
    private infoService: InfosComponent
  ) {
    this.languages = this.languageService.allLanguages;
    this.user = this.authService.currentUserValue;
    this.isUserAdmin = this.authService.isUserAdmin;
    this.isUserAll = this.authService.isUserAll;
  }

  @Output() settingsButtonClicked = new EventEmitter();

  displayCard() {
    setInterval(() => {
      let elementInfo = document.getElementById('status');
      this.showInfo =
        window.location.pathname != '/' &&
        window.location.pathname != '' &&
        this.isUserAdmin
          ? true
          : false;
      if (this.showInfo) {
        let gatewayStatus = this.infoService.topBarInfo();
        if (elementInfo != null) {
          elementInfo.style.backgroundColor = String(gatewayStatus);
        }
      }
    }, 30000);
  }

  routeToInfoPage() {
    this.router.navigate(['/']);
  }

  ngOnInit(): void {
    // this.displayCard();
    this.loadLanguage();
    if (this.user != null) {
      var dateAccessExpires = this.user.token
        ? this.user.token.accessExpires
        : new Date().getTime();
      this.tokenExpired =
        new Date(dateAccessExpires).getTime() - new Date().getTime() > 0
          ? false
          : true;

      this.timeToExpired =
        Math.abs(new Date(dateAccessExpires).getTime() - new Date().getTime()) *
        0.00001667 *
        60;
    }
  }

  /***
   * Language Value Set
   */
  setLanguage(lang: string) {
    this.languageService.setLanguage(lang);

    this.loadLanguage();
  }

  /**
   * Toggles the right sidebar
   */
  toggleRightSidebar() {
    this.settingsButtonClicked.emit();
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }

  changePassword() {
    this.router.navigate(['/auth/change-password']);
  }

  /**
   * Logout the user
   */
  logout() {
    this.authService.logout().subscribe((d) => {
      this.router.navigate(['/auth/login']);
    });
  }

  /**
   * Carrega a linguagem atual
   */
  private loadLanguage() {
    const language = this.languageService.location;

    this.countryName = language.name;
    this.flagvalue = language.flag;
    this.currentLang = language.language;
  }
}
